import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import ContentPiece   from '../../components/studio/ContentPiece';
import PartnerBrief   from '../../components/studio/PartnerBrief';
import ContentLibrary from '../../components/studio/ContentLibrary';
import { CHANNEL_META } from '../../utils/helpers';

export default function ContentStudio() {
  const { ideas, contentPieces, activeQueueId, setActiveQueueId } = useApp();
  const [libFilter, setLibFilter] = useState('all');

  const doneIdeas  = ideas.filter(i => i.status === 'done' || i.status === 'generating');
  const queueItems = doneIdeas.map(idea => ({
    idea,
    pieces: contentPieces.filter(p => p.idea_id === idea.id),
  }));

  const activePieces = activeQueueId
    ? contentPieces.filter(p => p.idea_id === activeQueueId)
    : [];

  const activeIdea = ideas.find(i => i.id === activeQueueId);

  return (
    <div className="studio-layout">
      {/* Queue sidebar */}
      <div className="studio-queue">
        <div className="studio-queue-head">
          <div className="sq-title">Content Queue</div>
          <div className="sq-sub">{queueItems.length} idea{queueItems.length !== 1 ? 's' : ''} with content</div>
        </div>

        {queueItems.length === 0 && (
          <div className="empty-state" style={{ padding:20 }}>
            Approve ideas in Idea Lab to generate content.
          </div>
        )}

        {queueItems.map(({ idea, pieces }) => (
          <div key={idea.id}
            className={`queue-item ${activeQueueId === idea.id ? 'active' : ''}`}
            onClick={() => setActiveQueueId(idea.id)}>
            <div className="qi-title">{idea.title}</div>
            <div className="qi-channels">
              {pieces.map(p => {
                const meta = CHANNEL_META[p.channel] || {};
                return (
                  <span key={p.id} className="qi-ch" style={{ background:meta.color }}>
                    {meta.emoji} {p.channel}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Main pane */}
      <div className="studio-main">
        {!activeQueueId && (
          <div className="studio-empty">
            <div>
              <div style={{ fontSize:32, marginBottom:10 }}>✍️</div>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:18, fontWeight:700, marginBottom:6 }}>
                Content Studio
              </div>
              <div>Select an idea from the queue, or approve one in Idea Lab.</div>
            </div>
          </div>
        )}

        {activeQueueId && activeIdea && (
          <>
            <div style={{ marginBottom:16, display:'flex', alignItems:'center', gap:10 }}>
              <button className="btn btn-outline btn-sm" onClick={() => setActiveQueueId(null)}>← Back</button>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:18, fontWeight:700 }}>
                {activeIdea.title}
              </div>
            </div>

            {activePieces.map(piece =>
              piece.channel === 'partner'
                ? <PartnerBrief key={piece.id} piece={piece} />
                : <ContentPiece  key={piece.id} piece={piece} />
            )}

            {activePieces.length === 0 && (
              <div className="info-box amber">⚠️ No content pieces found. Re-approve the idea in Idea Lab.</div>
            )}
          </>
        )}

        <ContentLibrary filter={libFilter} setFilter={setLibFilter} />
      </div>
    </div>
  );
}
